module.exports = __webpack_public_path__ + "img/border_right_long.1a130908.svg";